import React, { Component, Fragment } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import ReactDOM from "react-dom";
import { convertStringToElements } from "@vds/html-parsers";

import { media, isMobile } from "utils/style";
import { Tilelet, TileletGroup } from "@vds/tiles"
import { ListGroup, ListGroupItem, ListGroupItemTitle, ListGroupItemSubtitle } from "@vds/lists";
import { TitleLockup } from "@vds/type-lockups";
import { Body, Title } from "@vds/typography"
import { Grid, Row, Col } from "@vds/grids"
import { Button } from "@vds/buttons";


import { handleAEMReactLink } from "utils/handleAEMReactLink";
import { setA11yContent } from "../NavigationHelper/actions";

// import { Tile as ReactTile } from "common-components/Tile";
import AEMContentFromHTML from "../../../hoc/AEMContentFromHTML";
// import { isMoment, max } from "../../../../../node_modules/moment/moment";
// import { isCompositeComponent } from "../../../../../node_modules/react-dom/cjs/react-dom-test-utils.production.min";

class UniversalLanding extends Component {
  componentDidMount() {
    handleAEMReactLink();
    this.props.setA11yContent(
      "Universal landing page",
      this.props.pageContent.sc_pagetitle,
      this.props.pageContent.seo_description
    );
  }

  render() {
    const {
      sections: [
        [
          {
            collist: [firstColumnData, secondColumnData],
            banner: [bannerContent],
            richText: [topTilesHeadingContent],
            tile: [{ TileLinks: tilesList }],
            tileContent: otherTilesList
          }
        ]
      ]
    } = this.props.pageContent;

    const pageHeadingBackGroundColor =
      undefined !== bannerContent["backgroundcolor"] && "black" === bannerContent["backgroundcolor"]
        ? bannerContent["backgroundcolor"]
        : "white";
    const pageHeadingForeGroundColor =
      undefined !== bannerContent["backgroundcolor"] && "black" === bannerContent["backgroundcolor"]
        ? "white"
        : "black";

    const portalStyles = {
      outerDiv: {
        backgroundColor: pageHeadingBackGroundColor,
        color: pageHeadingForeGroundColor
      },
      innerDiv: {
        width: isMobile ? '328' : '623px',
        height: '120px',
      }
    };

    return (
      <Fragment>
        <Container style={{ marginTop: "24px", paddingTop: "0" }}>
          <SubContainer>
            <div style={portalStyles.innerDiv}>
              <TitleLockup
                surface='light'
                textAlignment='left'
                id="verizonPrivacyDashboad"
                viewport={isMobile ? "mobile" : "desktop"}
                data={{
                  title: {
                    size: 'titleXLarge',
                    bold: false,
                    primitive: 'h1',
                    children: bannerContent["bannerTitle"]
                  },
                  subtitle: {
                    size: 'titleLarge',
                    color: 'secondary',
                    children: bannerContent["bannerdescription"]
                  }
                }}
              />
            </div>

            <div style={{ margin: "24px auto" }} />
            <div style={{ maxWidth:  isMobile ? "328" : "597px" }}>
              <Body size='large' bold={false}>{convertStringToElements(firstColumnData.richText[0].description)}</Body>
            </div>

            <div style={{ clear: "both", margin: "91px 0 0 0" }} />
            <TitleLockup
              surface='light'
              textAlignment='left'
              id='privacyDataRequests'
              viewport={isMobile ? "mobile" : "desktop"}
              data={{
                title: {
                  size: 'titleLarge',
                  bold: true,
                  primitive: 'h2',
                  children: convertStringToElements(topTilesHeadingContent["title"])
                },
                subtitle: {
                  size: 'bodyLarge',
                  primitive: 'p',
                  children: <div style={{ width: isMobile ? '328' : '599px', height: '20px' }}>
                    <Body size='large'>{convertStringToElements(topTilesHeadingContent["description"])}</Body>
                  </div>
                }

              }}
            />
            <div style={{ clear: "both" }} />
            <TileContainer>
              {tilesList.map(tile => (
                <div key={tile.heading} >
                  <Tilelet
                    viewport={isMobile ? 'mobile' : 'desktop'}
                    href={tile.tileLink}
                    target='_blank'
                    title={{
                      bold: false,
                      size: 'titleSmall',
                      children: tile.heading
                      
                    }}
                    subtitle={{
                      bold: false,
                      children: <Body size='small'>{tile.linkText}</Body>

                    }}
                    directionalIcon={{
                      size: isMobile ? 'small' : 'medium'
                    }}
                    id={
                      tile.tileLink === "/privacy/your-data/login" ||
                        tile.tileLink === "/privacy/your-data/guest-landing" ||
                        tile.tileLink === "/privacy/your-data/former-customer"
                        ? "vpd_aem_react_link"
                        : ""
                    }
                    backgroundColor='secondary'
                    background='#F3EDE0'
                    tabIndex={0}
                    ariaLabel={tile.heading}
                    width={isMobile ? '165px' : '394.67px'}
                    height={ isMobile ? '216px' : '164px'}
                    aspectRatio="none"
                  />
                 </div>
              ))}
            </TileContainer>

            <div style={{ clear: "both" }} />
            <div style={{ maxWidth: '597px', margin: "91px 0 18px 0" }}>
              <TitleLockup
                surface='light'
                textAlignment='left'
                id='yourPrivacyChoices'
                aria-label={otherTilesList[0]["title"]}
                viewport={isMobile ? "mobile" : "desktop"}
                data={{
                  title: {
                    size: 'titleLarge',
                    bold: true,
                    primitive: 'h2',
                    children: convertStringToElements(otherTilesList[0]["title"])
                  },
                  subtitle: {
                    size: 'bodyLarge',
                    children: otherTilesList[0]["tileDescription"]
                  }

                }}
              />
              <div style={{ marginBottom: "20px" }} />
              <Button
                size="large"
                disabled={false}
                use="secondary"
                width="138px"
                aria-label={otherTilesList[0].list[0].linkText}
                onClick={() => window.open(otherTilesList[0].list[0].tileLink, '_blank')}>
                <Body size='large' bold={true}>{otherTilesList[0].list[0].linkText}</Body>
              </Button>
            </div>
            <div style={{ clear: "both", marginBottom: "56px" }} />

            <div style={{ clear: "both" }} />
            <div style={{ maxWidth: '597px' }}>
              <TitleLockup
                surface='light'
                textAlignment='left'
                id='additionalPrivacyControls'
                aria-label={otherTilesList[1]["title"]}
                viewport={isMobile ? "mobile" : "desktop"}
                data={{
                  title: {
                    size: 'titleLarge',
                    bold: true,
                    primitive: 'h2',
                    children: convertStringToElements(otherTilesList[1]["title"])
                  },
                  subtitle: {
                    size: 'bodyLarge',
                    children: otherTilesList[1]["tileDescription"]
                  }

                }}
              />
              <div style={{ marginBottom: "20px" }} />
              <Button
                size="large"
                disabled={false}
                use="secondary"
                width="100px"
                aria-label={otherTilesList[1].list[0].linkText}
                onClick={() => window.open(otherTilesList[1].list[0].tileLink, '_blank')}>
                <Body size='large' bold={true}>{otherTilesList[1].list[0].linkText}</Body>
              </Button>
            </div>

            <div style={{ clear: "both", marginBottom: "80px" }} />

            <Fragment>
              <TitleLockup
                surface='light'
                textAlignment='left'
                id='additionalResources'
                viewport={isMobile ? "mobile" : "desktop"}
                data={{
                  title: {
                    size: 'titleLarge',
                    bold: true,
                    primitive: 'h2',
                    children: <span style={{ margin: "80px 0px 0px 0px" }}>{convertStringToElements(otherTilesList[2]["title"])}</span>
                  }
                }}

              />
              <div style={{ clear: "both", marginBottom: "43px" }} />
              <Grid
                rowGutter="0px"
                colSizes={{ desktop: 6, tablet:6, mobile: 4 }}
              >
                <Row>
                  {otherTilesList[2].list.map(tile => (
                    <Col key={tile.heading}>
                        <ListGroup
                          topLine={false}
                          bottomLine={true}
                          surface="light"
                        >
                          <ListGroupItem onClick={() => tile.heading === 'Related articles about privacy' ?
                            (() => {
                              const newTab = window.open(tile.tileLink, '_blank');
                              setTimeout(() => {
                                if (newTab) {
                                  newTab.location.href = tile.tileLink + '#article_blog_bm_2';
                                }
                              }, 500);
                            })()
                            :
                            window.open(tile.tileLink, '_blank')} id={tile.className ? tile.className : ""} actionElement="icon" >
                            <ListGroupItemTitle bold={false}>
                              <span className="agent_tile_heading">{tile.heading}</span>
                            </ListGroupItemTitle>
                          </ListGroupItem>
                        </ListGroup>
                    </Col>
                  ))}
                </Row>
              </Grid>
              <div style={{ clear: "both", marginBottom: "80px" }} />
            </Fragment>
          </SubContainer>
        </Container>
      </Fragment>
    );
  }
}

export default compose(
  connect(
    null,
    { setA11yContent }
  ),
  AEMContentFromHTML
)(UniversalLanding);


// const CommonTile = styled(ReactTile)`
//   flex-basis: 50%;

//   ${media.mobile`
//     flex-basis: 100%;
//   `}
// `;

// const Tile = styled.div`
//   height: ${props => (props.tileText ? "348px" : "174px")};
//   background-color: ${props => (props.bgColor ? props.bgColor : "white")};

//   float: left;
//   width: ${props => (props.twoTilePerRow ? "50%" : "33.33%")};

//   a {
//     position: relative;
//     font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
//     font-weight: 700;
//     text-decoration: none;
//     font-size: 32px;
//     line-height: 30px;
//     box-shadow: 1px 0 0 0 #d8dada, 0 1px 0 0 #d8dada, 1px 1px 0 0 #d8dada, 1px 0 0 0 #d8dada inset,
//       0 1px 0 0 #d8dada inset;
//     height: 100%;
//     width: 100%;
//     display: inline-block;

//     color: ${props => (undefined !== props.bgColor && "black" === props.bgColor ? "white" : "black")};
//   }

//   a span {
//     position: absolute;
//     top: ${props => (props.tileText ? "52px" : "17px")};
//     left: 20px;
//     max-width: 88%;
//   }

//   a span.agent_tile_heading {
//     position: absolute;
//     top: ${props => (props.tileText ? "52px" : "17px")};
//     left: 20px;
//     max-width: 75%;
//     font-family: Verizon NHG DS, Helvetica, Arial, sans-serif;
//   }

//   a span.tile_text {
//     top: 35%;
//     margin-top: 50px;
//     left: 20px;
//     font-family:"Verizon NHG DS", Helvetica, Arial, sans-serif;
//     font-size: 20px;
//     font-weight: 400;
//     line-height: 24px;
//     border-top: 1pt solid black;
//     padding-top: 24px;
//   }

//   a span.tile_text_privacy_policy {
//     font-family: Verizon NHG DS;
//     font-size: 10px;
//     line-height: 10px;
//     font-weight: 400;
//     top: 54%;
//     width: 268px;
//   }

//   .tile_arrow {
//     height: ${props => (props.tileText ? "14px" : "18px")};
//     width: ${props => (props.tileText ? "14px" : "18px")};
//     font-family: NeueHaasGroteskDisplay, Helvetica, Arial, sans-serif;
//     transform: rotate(-45deg);
//     bottom: 20px;
//     right: 20px;
//     top: ${props => (props.tileText ? "90%" : "80%")};
//     left: ${props => (props.tileText ? "90%" : props.twoTilePerRow ? "93%" : "90%")};
//     border-right: 3px solid;
//     border-bottom: 3px solid;
//   }

//   a:focus {
//     z-index: 99;
//   }

//   ${media.tablet`
//     width: 50%;    
//   `}

//   ${media.mobile`  
//     width: 100%;
//     .tile_arrow {
//       top: ${props => (props.tileText ? "90%" : "80%")};
//       left: 90%
//     }
//   `}
// `;

// const H1 = styled.h1`
//   font-size: 64px;
//   line-height: 64px;
//   max-width: 597px;
//   padding: 80px 20px 119px 20px;
//   font-family: Verizon NHG DS;
//   font-weight: 700;


//   ${media.mobile`
//     font-size: 50px;
//     line-height: 48px;
//   `};
// `;

// const H2 = styled.h2`
//   margin-bottom: 20px;

//   span {
//     height: 5px;
//     display: block;
//     width: 49px;
//     background-color: #d52b1e;
//     margin-top: 16px;
//   }

//   ${media.mobile`
//     margin-top: 55px;
//     margin-bottom: 12px;
//     font-size: 25px;  
//     line-height: 24px;
//   `};
// `;
const TileContainer = styled.div`
  margin: 36px auto;
  display: flex;
  gap: 24px;
  flex-wrap: wrap

  ${media.mobile`
    margin: 75px auto;
  `};
`;

const Container = styled.div`
  max-width: 1272px;
  margin: 0 auto;
  padding: 48px 0;

  ${media.mobile`
    margin: 25px auto;
    padding: 0;
  `};
`;

const SubContainer = styled.div`
  padding: 0 20px;

  ${media.mobile`
    padding: 0 16px;
  `};
`;

// const PrivacyAction = styled.div`
//   display:flex;
//   flex-direction:row;
//   gap:30px;
//   align-items:center;
// `;

const Div = styled.div`
  float: left;

  span.red_line {
    height: 5px;
    display: block;
    width: 49px;
    background-color: #d52b1e;
    margin-top: 16px;
  }

  p {
    padding: 10px 0;
    font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
    font-size: 20px;
    line-height: 24px;
  }

  div.actionList {
    max-width: 570px;
    margin-left:43px;
  }

  
  span.svg > svg {
    vertical-align: middle;
  }

  ${media.mobile`  
    div {
      margin: 20px 0;
    }
    div:nth-of-type(2) span {
      margin-left: 0;
    }


    div.actionList {
      margin-left: 0px;
    }

    div:last-of-type span {
      margin-left: 0;
    }

  `}
`;

// const DivSmall = styled(Div)`
//   max-width: 33.33%;
// `;

// const H2Small = styled(H2)`
//   max-width: 33.33%;
// `;
